function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M403.409,351.719c-0.7-4.141-4.626-6.93-8.764-6.231c-4.141,0.7-6.931,4.623-6.232,8.764l16.855,99.823 c-1.147,18.019-59.989,42.718-155.229,42.718c-95.247,0-154.094-24.7-155.241-42.719l15.875-94.025 c0.699-4.141-2.092-8.064-6.232-8.764c-4.143-0.7-8.064,2.092-8.764,6.232l-15.999,94.755c-0.07,0.418-0.105,0.841-0.105,1.266 c0,17.438,18.341,32.384,53.038,43.22C164.087,506.587,205.791,512,250.04,512c44.244,0,85.944-5.413,117.418-15.242 c34.697-10.836,53.037-25.781,53.037-43.22c0-0.424-0.035-0.848-0.105-1.266L403.409,351.719z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M79.652,258.962c-7.302-19.943-11.004-40.927-11.004-62.367c0-100.017,81.369-181.387,181.386-181.387 c27.444,0,53.808,5.972,78.357,17.75c3.787,1.817,8.328,0.219,10.145-3.567c1.817-3.787,0.219-8.329-3.567-10.145 C308.35,6.476,279.773,0,250.033,0C141.631,0,53.44,88.192,53.44,196.594c0,23.23,4.014,45.973,11.931,67.596 c1.128,3.081,4.04,4.991,7.141,4.991c0.868,0,1.752-0.15,2.614-0.465C79.07,267.272,81.096,262.905,79.652,258.962z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M428.269,133.133c-4.01,1.247-6.249,5.509-5.002,9.519c5.41,17.395,8.153,35.543,8.153,53.941 c0,100.016-81.369,181.387-181.387,181.387c-32.555,0-64.483-8.722-92.329-25.223c-27.048-16.028-49.598-38.919-65.212-66.199 c-2.087-3.645-6.733-4.908-10.377-2.823c-3.645,2.087-4.908,6.732-2.823,10.377c16.917,29.558,41.35,54.361,70.658,71.728 c30.192,17.891,64.8,27.348,100.081,27.348c108.402,0,196.595-88.192,196.595-196.595c0-19.931-2.975-39.599-8.84-58.458 C436.541,134.126,432.282,131.887,428.269,133.133z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M444.691,85.29l-21.963-4.453c-18.691-3.79-33.215-18.314-37.005-37.005L381.27,21.87C379.614,13.703,372.639,8,364.307,8 l0,0c-8.332,0-15.308,5.703-16.964,13.87l-4.453,21.962c-3.789,18.69-18.314,33.215-37.005,37.005l-21.963,4.453 c-8.166,1.656-13.87,8.631-13.87,16.964s5.703,15.308,13.87,16.964l21.963,4.453c18.691,3.79,33.215,18.314,37.005,37.005 l4.453,21.962c1.656,8.167,8.632,13.87,16.964,13.87s15.308-5.703,16.963-13.87l4.453-21.962 c3.789-18.691,18.314-33.215,37.005-37.005l0,0l21.963-4.453c8.167-1.656,13.87-8.631,13.87-16.964S452.857,86.946,444.691,85.29z M441.669,104.312l-21.963,4.453c-24.692,5.006-43.881,24.196-48.887,48.887l-4.453,21.962c-0.084,0.417-0.341,1.683-2.059,1.683 c-1.717,0-1.975-1.267-2.059-1.683l-4.453-21.962c-5.006-24.692-24.196-43.881-48.887-48.887l-21.963-4.453 c-0.417-0.084-1.683-0.342-1.683-2.059s1.267-1.975,1.683-2.059l21.963-4.453c24.692-5.006,43.881-24.196,48.887-48.887 l4.453-21.962c0.084-0.417,0.341-1.684,2.059-1.684c1.717,0,1.975,1.267,2.059,1.683l4.453,21.962 c5.006,24.692,24.196,43.881,48.887,48.887l21.963,4.453c0.417,0.084,1.683,0.342,1.683,2.059S442.085,104.228,441.669,104.312z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M235.627,230.25l6.416,1.301c13.196,2.676,23.451,12.931,26.126,26.127l1.301,6.415c1.485,7.326,7.743,12.443,15.218,12.443 l0,0c7.475,0,13.734-5.117,15.219-12.443l1.301-6.416c2.676-13.195,12.931-23.452,26.127-26.127l6.416-1.301 c7.326-1.485,12.443-7.744,12.443-15.219s-5.117-13.734-12.443-15.219l-6.416-1.301c-13.196-2.676-23.452-12.931-26.127-26.127 l-1.301-6.416c-1.485-7.326-7.744-12.443-15.22-12.443c-7.475,0-13.733,5.117-15.218,12.442l-1.301,6.416 c-2.676,13.196-12.93,23.452-26.126,26.127l-6.416,1.301c-7.326,1.485-12.442,7.744-12.442,15.219 C223.184,222.504,228.301,228.765,235.627,230.25z M238.405,214.794c0,0,0.066-0.041,0.244-0.077l6.416-1.301 c19.198-3.892,34.117-18.812,38.01-38.01l1.301-6.416c0.025-0.127,0.054-0.197,0.052-0.211c0.128-0.064,0.43-0.062,0.5-0.033 c0,0.001,0.041,0.067,0.077,0.244l1.301,6.416c3.892,19.198,18.812,34.117,38.01,38.01l6.416,1.301 c0.128,0.025,0.202,0.06,0.211,0.052c0.064,0.129,0.062,0.431,0.033,0.5c0,0-0.067,0.041-0.245,0.077l-6.416,1.301 c-19.197,3.892-34.117,18.811-38.01,38.01l-1.301,6.415c-0.025,0.127-0.054,0.198-0.052,0.211c-0.128,0.064-0.43,0.062-0.5,0.033 c0-0.001-0.041-0.067-0.077-0.245l-1.301-6.416c-3.892-19.197-18.811-34.117-38.01-38.01l-6.416-1.301 c-0.124-0.025-0.193-0.053-0.21-0.053l0,0C238.375,215.165,238.376,214.863,238.405,214.794z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M218.455,111.112c4.199,0,7.604-3.405,7.604-7.604V83.739c0-4.199-3.405-7.604-7.604-7.604 c-4.199,0-7.604,3.405-7.604,7.604v19.769C210.851,107.708,214.254,111.112,218.455,111.112z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M210.851,156.734c0,4.199,3.405,7.604,7.604,7.604c4.199,0,7.604-3.405,7.604-7.604v-19.769 c0-4.199-3.405-7.604-7.604-7.604c-4.199,0-7.604,3.405-7.604,7.604V156.734z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M254.952,127.84c4.199,0,7.604-3.405,7.604-7.604c0-4.199-3.405-7.604-7.604-7.604h-19.769 c-4.199,0-7.604,3.405-7.604,7.604c0,4.199,3.405,7.604,7.604,7.604H254.952z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M181.957,112.632c-4.199,0-7.604,3.405-7.604,7.604c0,4.199,3.405,7.604,7.604,7.604h19.769 c4.199,0,7.604-3.405,7.604-7.604c0-4.199-3.405-7.604-7.604-7.604H181.957z"
});

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

var _ref24 = /*#__PURE__*/React.createElement("g", null);

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Capa_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 512 512",
  style: {
    "enableBackground": "new 0 0 512 512"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#F9D366"
  },
  d: "M412.895,453.54c0,28.084-72.917,50.855-162.857,50.855c-23.197,0-45.269-1.511-65.242-4.248 c-57.476-7.857-97.625-25.772-97.625-46.607l22.092-130.839c0,0,0,0,0-0.01l85.195,0.01l196.344,0.01L412.895,453.54z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#DD8833"
  },
  d: "M195.645,333.134l-10.848,167.013c-57.476-7.857-97.625-25.772-97.625-46.607l22.092-130.839 c0,0,0,0,0-0.01l85.195,0.01L195.645,333.134z"
}), /*#__PURE__*/React.createElement("circle", {
  style: {
    "fill": "#CF8BFC"
  },
  cx: 250.039,
  cy: 196.598,
  r: 188.994
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#CFB1FC"
  },
  d: "M250.034,7.604c-5.12,0-10.19,0.211-15.207,0.61c55.948,4.455,105.027,33.275,136.628,75.846 c12.929,17.416-2.636,41.396-23.927,37.252c-6.272-1.221-12.784-1.769-19.458-1.568c-45.057,1.361-82.032,37.46-84.392,82.476 c-2.637,50.3,37.367,91.911,87.091,91.911c0.259,0,0.517-0.001,0.776-0.003c21.66-0.189,32.462,26.292,16.585,41.027 c-30.24,28.064-69.683,46.347-113.302,49.82c5.017,0.399,10.087,0.61,15.207,0.61c104.377,0,188.991-84.614,188.991-188.991 S354.41,7.604,250.034,7.604z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#9966CC"
  },
  d: "M144.683,196.595c0-90.005,62.919-165.305,147.17-184.338c-13.453-3.04-27.447-4.653-41.819-4.653 c-104.377,0-188.991,84.614-188.991,188.99s84.614,188.991,188.991,188.991c14.372,0,28.366-1.613,41.82-4.652 C207.602,361.9,144.683,286.598,144.683,196.595z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#F9D366"
  },
  d: "M421.217,116.218l21.962-4.453c10.369-2.102,10.369-16.92,0-19.023l-21.962-4.453 c-21.643-4.388-38.558-21.303-42.946-42.946l-4.453-21.962c-2.102-10.369-16.92-10.369-19.023,0l-4.453,21.962 c-4.388,21.643-21.303,38.558-42.946,42.946l-21.962,4.453c-10.369,2.102-10.369,16.92,0,19.023l21.962,4.453 c21.643,4.388,38.558,21.303,42.946,42.946l4.453,21.962c2.102,10.369,16.92,10.369,19.023,0l4.453-21.962 C382.659,137.52,399.574,120.606,421.217,116.218z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#F9D366"
  },
  d: "M325.826,224.098l6.416-1.301c8.467-1.716,8.467-13.817,0-15.533l-6.416-1.301 c-16.161-3.277-28.792-15.907-32.068-32.068l-1.301-6.416c-1.716-8.467-13.817-8.467-15.533,0l-1.301,6.416 c-3.277,16.161-15.907,28.792-32.068,32.068l-6.416,1.301c-8.467,1.716-8.467,13.817,0,15.533l6.416,1.301 c16.161,3.277,28.792,15.907,32.068,32.068l1.301,6.416c1.716,8.467,13.817,8.467,15.533,0l1.301-6.416 C297.034,240.005,309.665,227.375,325.826,224.098z"
})), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);

export default __webpack_public_path__ + "static/media/bouleCristal.28e12981.svg";
export { SvgComponent as ReactComponent };